var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1409_29503)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#886DF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1409_29503)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1409_29503)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1562 11.7188H11.7812C11.6569 11.7188 11.5377 11.6694 11.4498 11.5815C11.3619 11.4935 11.3125 11.3743 11.3125 11.25C11.3125 11.1257 11.3619 11.0065 11.4498 10.9185C11.5377 10.8306 11.6569 10.7812 11.7812 10.7812H19.75C19.8743 10.7812 19.9935 10.7319 20.0815 10.644C20.1694 10.556 20.2188 10.4368 20.2188 10.3125C20.2188 10.1882 20.1694 10.069 20.0815 9.98104C19.9935 9.89314 19.8743 9.84375 19.75 9.84375H11.7812C11.4083 9.84375 11.0506 9.99191 10.7869 10.2556C10.5232 10.5194 10.375 10.877 10.375 11.25V18.75C10.375 19.123 10.5232 19.4806 10.7869 19.7444C11.0506 20.0081 11.4083 20.1562 11.7812 20.1562H21.1562C21.4049 20.1562 21.6433 20.0575 21.8192 19.8817C21.995 19.7058 22.0938 19.4674 22.0938 19.2188V12.6562C22.0938 12.4076 21.995 12.1692 21.8192 11.9933C21.6433 11.8175 21.4049 11.7188 21.1562 11.7188ZM19.0469 16.4062C18.9078 16.4062 18.7719 16.365 18.6562 16.2878C18.5406 16.2105 18.4505 16.1007 18.3973 15.9722C18.3441 15.8437 18.3301 15.7023 18.3573 15.566C18.3844 15.4296 18.4514 15.3043 18.5497 15.2059C18.648 15.1076 18.7733 15.0406 18.9097 15.0135C19.0461 14.9864 19.1875 15.0003 19.3159 15.0535C19.4444 15.1067 19.5542 15.1969 19.6315 15.3125C19.7088 15.4281 19.75 15.5641 19.75 15.7031C19.75 15.8896 19.6759 16.0684 19.5441 16.2003C19.4122 16.3322 19.2334 16.4062 19.0469 16.4062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1409_29503",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1409_29503"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.284122 0 0 0 0 0.00449997 0 0 0 0 0.8955 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_29503"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145413 0 0 0 0 0.0684 0 0 0 0 0.3116 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1409_29503",
    result: "effect2_dropShadow_1409_29503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1409_29503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1409_29503",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1409_29503",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBtn);
export default __webpack_public_path__ + "static/media/walletBtn.c45522f8edc4f3ae39bf9c45c6678981.svg";
export { ForwardRef as ReactComponent };